import React from 'react'

const Heart = ({ className }) => {
  return (
    <svg
      className={className}
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1 22.55L16 22.65L15.9 22.55C11.14 18.24 8 15.39 8 12.5C8 10.5 9.5 9 11.5 9C13.04 9 14.54 9.99 15.07 11.36H16.94C17.46 9.99 18.96 9 20.5 9C22.5 9 24 10.5 24 12.5C24 15.39 20.86 18.24 16.1 22.55Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.5 7C18.76 7 17.09 7.81 16 9.09C14.91 7.81 13.24 7 11.5 7C8.42 7 6 9.42 6 12.5C6 16.28 9.4 19.36 14.55 24.04L16 25.35L17.45 24.03C22.6 19.36 26 16.28 26 12.5C26 9.42 23.58 7 20.5 7ZM16.1 22.55L16 22.65L15.9 22.55C11.14 18.24 8 15.39 8 12.5C8 10.5 9.5 9 11.5 9C13.04 9 14.54 9.99 15.07 11.36H16.94C17.46 9.99 18.96 9 20.5 9C22.5 9 24 10.5 24 12.5C24 15.39 20.86 18.24 16.1 22.55Z'
        fill='white'
      />
    </svg>
  )
}

export default Heart
